export const SHIPPING_COST = 50

const firstRangeLimit = 50000
const firstRangeFee = 28
const firstRangePercentage = firstRangeFee / 100

const secondRangeLimit = 1_000_000
const secondRangeFee = 27
const secondRangePercentage = secondRangeFee / 100

const thirdRangeLimit = 6_000_000
const thirdRangeFee = 21
const thirdRangePercentage = thirdRangeFee / 100

const fourthRangeFee = 14.5
const fourthRangePercentage = fourthRangeFee / 100

// (28 * 50000 + 27 * (hammerPrice - 50000)) / 100 =
// (1400000 - 1300000 + 27 * hammerPrice) / 100 =
// (100000 + 27 * hammerPrice) / 100 =
// 1000 + 0.27 * hammerPrice
// firstRangeCompletedFee + secondRangePercentage * hammerPrice
const firstRangeFullFee =
  (firstRangeFee * firstRangeLimit - secondRangeFee * firstRangeLimit) / 100

// (28 * 50000 + 27 * (1000000 - 50000) + 21 * (hammerPrice - 1000000)) / 100 =
// (1400000 + 25650000 - 21000000 + 21 * hammerPrice) / 100 =
// (6050000 + 21 * hammerPrice) / 100 =
// 60500 + 0.21 * hammerPrice =
// secondRangeCompletedFee + thirdRangePercentage * hammerPrice
const secondRangeFullFee =
  (firstRangeFee * firstRangeLimit +
    secondRangeFee * (secondRangeLimit - firstRangeLimit) -
    thirdRangeFee * secondRangeLimit) /
  100

// (28 * 50000 + 27 * (1000000 - 50000) + 21 * (6000000 - 1000000) + 14.5 * (hammerPrice - 6000000)) / 100 =
// (1400000 + 1350000 + 105000000 - 87000000 + 14.5 * hammerPrice) / 100 =
// (20750000 + 14.5 * hammerPrice) / 100 =
// 207500 + 0.145 * hammerPrice =
// thirdRangeCompletedFee + fourthRangePercentage * hammerPrice
const thirdRangeFullFee =
  (firstRangeFee * firstRangeLimit +
    secondRangeFee * (secondRangeLimit - firstRangeLimit) +
    thirdRangeFee * (thirdRangeLimit - secondRangeLimit) -
    fourthRangeFee * thirdRangeLimit) /
  100

/**
 * 
 * @param hammerPrice 
 * @returns 28% on the first $50,000 of the hammer price
            27% of the hammer price of amounts in excess of $50,000 up to and including $1,000,000
            21% of the hammer price of amounts in excess of $1,000,000 up to and including $6,000,000
            14.5% of the hammer price of any amounts in excess of $6,000,000
 */

export const getBuyersPremium = (hammerPrice: number) => {
  if (hammerPrice < 0) {
    return 0
  } else if (hammerPrice <= firstRangeLimit) {
    return firstRangePercentage * hammerPrice
  } else if (hammerPrice <= secondRangeLimit) {
    return firstRangeFullFee + secondRangePercentage * hammerPrice
  } else if (hammerPrice <= thirdRangeLimit) {
    return secondRangeFullFee + thirdRangePercentage * hammerPrice
  } else {
    return thirdRangeFullFee + fourthRangePercentage * hammerPrice
  }
}

/**
 *
 * @param hammerPrice
 * @returns 1% of the hammerPrice
 */
export const getShippingInsurance = (hammerPrice: number) => {
  return 0.01 * hammerPrice
}

export const getTotal = (hammerPrice: number) => {
  return (
    hammerPrice +
    getBuyersPremium(hammerPrice) +
    getShippingInsurance(hammerPrice) +
    SHIPPING_COST
  )
}

export const getNumberFormat = (value: number) => {
  const formatter = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'USD',
    currencyDisplay: 'narrowSymbol',
    maximumFractionDigits: 2,
  })
  return formatter.format(value)
}
